<template>
    <g v-if="pathfinder" class="layer layer-map-debug-pathfinder">
        <g v-for="(node, index) in floorNodes" :key="'link-'+index">
            <line class="map-item-link"
                  :x1="node.from.x" :y1="node.from.y"
                  :x2="node.to.x" :y2="node.to.y" :style="lineStyle(node)"/>

            <text :x="node.link.getMiddlePoint().x" :y="node.link.getMiddlePoint().y" font-weight="bold" :font-size="pxToSVGScale(12)">
                [{{node.cost|round}}]
            </text>
        </g>
    </g>
</template>

<script>
import MapMixin from "@/helpers/maps/map-mixin.js";
export default {
    name: `layer-map-debug-pathfinder`,
    mixins: [MapMixin],
    props: {
        pathfinder: { type: Object, required: true }
    },
    inject: [`pxToSVGScale`],
    computed: {
        floorNodes() {
            return this.pathfinder.debugNodes.filter(n => n.link.isLinkOnFloor(this.currentFloor.id));
        }
    },
    methods: {
        lineStyle(node) {
            let style = {};
            if (node.cost > 100) {
                style.stroke = `red`;
            } else if (node.cost > 50) {
                style.stroke = `orange`;
            }

            return style;
        }
    }
}
</script>

<style lang="scss" scoped>
.layer-map-debug-pathfinder {
    z-index: 0;

    .map-item-link {
        stroke: rgba(black, 0.25);
        stroke-linecap: round;
        stroke-width: calc(4 * var(--px-to-svg));
    }
}
</style>
